import { Divider, Flex, HStack, Image, Text } from '@chakra-ui/react';

export const LGPDHeader = (): JSX.Element => {
  return (
    <Flex
      minH="5.6rem"
      w="100%"
      align="center"
      justify="space-between"
      p="1vw 1.9vw"
      bg="#FFFFFF"
      fontSize="1.5rem"
    >
      <Flex>
        <HStack
          flexDir={{ base: 'column', md: 'row' }}
          spacing={2}
          p="0rem 1rem 0rem 0.6rem"
        >
          <Image src="/images/logo-sulAmerica.png" w="5rem" />
        </HStack>
      </Flex>
    </Flex>
  );
};
